<template>
  <div id="app">
    <transition name="router-fade" mode="out-in">
      <!--主要切换内容-->
      <router-view ref="routerView"/>
    </transition>
  </div>
</template>

<script>
  import $ from './jslib/jquery-3.1.1.min'
  import rem from './jslib/rem'
  import utils from './jslib/utils'
  import common from "./mixins/common"
  import { Indicator } from 'mint-ui';
  import store from "./vuex/store"
  import {appDomain} from "./jslib/env";

  export default {
    name: 'app',
    store,
    data() {
      return {
        text: 123,
        transitionName: ''
      }
    },
    watch: {//使用watch 监听$router的变化
      $route(to, from) {
        // debugger
        //如果to索引大于from索引,判断为前进状态,反之则为后退状态
        // if (to.meta.index > from.meta.index) {
        //   //设置动画名称
        //   this.transitionName = 'slide-left';
        // } else {
        //   this.transitionName = 'slide-right';
        // }

        store.state.lastPath = from.path
        console.log("FullPath", to.fullPath)
        console.log("LastPath", from.fullPath)

        // 设置页面标题
        window.document.title = to.meta && to.meta.title ? to.meta.title : ''

        // 路由发生改变时调用
        this.onRouteChange(to)

      }
    },
    created() {
      this.initGlobalCubeUi()
    },
    methods: {

      // 跳转到定制页面
      toCustom(class_id) {
        this.$utils.setCookie("class_id", class_id);
        this.$router.push({path: 'custom'});
      },

      /**
       * 注入cube-ui常用组件到全局window对象
       */
      initGlobalCubeUi() {
        // type可选择:correct,error,warn,loading,txt
        window.toast = (msg, type = 'error') => {
          Toast({
            message: msg,
            duration: 1000
          });
        };
        window.showLoading = () => {
          Indicator.open();
        }
        window.hideLoading = () => {
          Indicator.close();
        }

        // 显示或隐藏返回按钮
        window.hideBackBtn = (hide = true) => {
          try{ document.getElementsByClassName("btn-back")[0].style.display = hide ? 'none' : '' }catch (e) {
            try{ document.getElementsByClassName("back-btn")[0].style.display = hide ? 'none' : '' }catch (e) {
              console.log("隐藏/显示返回按钮失败", e)
            }
          }
        }

        window.h5Methods = common.methods

      },

      // 路由改变时的调用
      onRouteChange(to){

        if(['/housegoodsdetail'].includes(to.path.toLowerCase())){
          this.$nextTick(()=>{
            let count = 0
            let updateInterval = setInterval( () => {
              count++
              if(count > 30) clearInterval(updateInterval)
              if(this.$refs.routerView){
                clearInterval(updateInterval)
                if(this.$refs.routerView.onRouteChange) this.$refs.routerView.onRouteChange()
              }
            }, 1000)

          })
        }

      },

    }
  }
</script>

<style lang="scss">
  @import "./assets/style/public.scss";

  .router-fade-enter-active,
  .router-fade-leave-active {
    transition: opacity 0.3s;
  }

  .router-fade-enter,
  .router-fade-leave-active {
    opacity: 0;
  }
</style>
